import React from "react";
import {
  TextAreaWithLabel,
  Row,
} from "@d-lighted/design-system";
import RequiredMark from "./RequiredMark";

export default function TextFieldCase({ data }) {
  const required = data.bookingCalendarSettingBookingCalendarCustomField.inputRequired;
  return (
    <Row key={data.uid} mt="15px" alignItems="center" mb="1rem">
      <TextAreaWithLabel 
        id={data.uid}
        labelLeft={
          <span>
            {data.labelName}
            {required && <RequiredMark />}
          </span>
        }
        placeholder="" />
    </Row>
  )
}
